var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { CircularProgress, Fab } from "@mui/material";
import { WorkflowAttachmentType } from "../models";
import "./workflow-step-view.scss";
import LocalSeeOutlinedIcon from '@mui/icons-material/LocalSeeOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import WorkflowStepHelp from "./workflow-step-help";
import { workflowAttachmentApi } from "../workflow-attachment-api";
export default function WorkflowStepView(props) {
    var _this = this;
    var _a = useState(false), isPhotoMode = _a[0], setIsPhotoMode = _a[1];
    var _b = useState(false), isPhotoTaken = _b[0], setIsPhotoTaken = _b[1];
    var _c = useState(false), isFinishVisible = _c[0], setIsFinishVisible = _c[1];
    var _d = useState(false), isHelpDialogOpen = _d[0], setIsHelpDialogOpen = _d[1];
    var _e = useState(""), overlayUrl = _e[0], setOverlayUrl = _e[1];
    var _f = useState(false), isUploadingPhoto = _f[0], setIsUploadingPhoto = _f[1];
    useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var overlay;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsPhotoMode(false);
                        setIsPhotoTaken(false);
                        setIsFinishVisible(false);
                        if (!props.step.overlayImageFileId) return [3 /*break*/, 2];
                        return [4 /*yield*/, workflowAttachmentApi.getAttachmentByType(props.step.caseTypeId, props.step.id, WorkflowAttachmentType.Overlay)];
                    case 1:
                        overlay = _a.sent();
                        setOverlayUrl(overlay.url);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); })();
    }, [props.step]);
    function renderHeader() {
        if (isPhotoMode)
            return null;
        return (_jsx("div", __assign({ className: "workflow-step-view__header" }, { children: props.step.title }), void 0));
    }
    function renderLogo() {
        if (isPhotoMode)
            return null;
        return (_jsx("img", { className: "workflow-step-view__logo", src: "/Content/Images/Logo-short.png", width: "42px", height: "42px", alt: "youCit" }, void 0));
    }
    function renderFooter() {
        if (isPhotoMode)
            return null;
        if (!props.step.description)
            return null;
        return (_jsx("div", __assign({ className: "workflow-step-view__footer" }, { children: props.step.description }), void 0));
    }
    function renderCancelButton() {
        if (isUploadingPhoto || !isPhotoMode || isPhotoTaken)
            return null;
        return (_jsx(Fab, __assign({ color: "default", size: "medium", className: "workflow-step-view__cancel-button", onClick: function () { return setIsPhotoMode(false); } }, { children: _jsx(CancelOutlinedIcon, {}, void 0) }), void 0));
    }
    function renderStartButton() {
        if (isUploadingPhoto || isPhotoMode)
            return null;
        return (_jsx(Fab, __assign({ color: "primary", size: "large", className: "workflow-step-view__start-button", onClick: function () { return setIsPhotoMode(true); } }, { children: "Start" }), void 0));
    }
    function renderFinishButton() {
        if (isUploadingPhoto || !isFinishVisible || isPhotoTaken)
            return null;
        return (_jsx(Fab, __assign({ color: "primary", size: "medium", className: "workflow-step-view__finish-button", onClick: function () { return props.onStepComplete(); } }, { children: "Next" }), void 0));
    }
    function renderTakePhotoButton() {
        if (isUploadingPhoto || !isPhotoMode || isPhotoTaken)
            return null;
        return (_jsx(Fab, __assign({ color: "primary", size: "large", className: "workflow-step-view__take-photo-button", onClick: function () {
                var _a;
                (_a = props.takePhoto) === null || _a === void 0 ? void 0 : _a.call(props);
                setIsPhotoTaken(true);
            } }, { children: _jsx(LocalSeeOutlinedIcon, {}, void 0) }), void 0));
    }
    function renderAcceptPhotoButton() {
        if (isUploadingPhoto || !isPhotoMode || !isPhotoTaken)
            return null;
        return (_jsx(Fab, __assign({ color: "primary", size: "large", className: "workflow-step-view__accept-photo-button", onClick: function () {
                var _a;
                setIsUploadingPhoto(true);
                (_a = props.acceptPhoto) === null || _a === void 0 ? void 0 : _a.call(props, function () {
                    setIsUploadingPhoto(false);
                    if (props.step.isMultiAttachment) {
                        setIsPhotoTaken(false);
                        setIsFinishVisible(true);
                    }
                    else {
                        props.onStepComplete();
                    }
                }, props.step.fileCategoryId);
            } }, { children: _jsx(CheckCircleOutlinedIcon, {}, void 0) }), void 0));
    }
    function renderRedoPhotoButton() {
        if (isUploadingPhoto || !isPhotoMode || !isPhotoTaken)
            return null;
        return (_jsx(Fab, __assign({ color: "default", size: "medium", className: "workflow-step-view__redo-photo-button", onClick: function () { return setIsPhotoTaken(false); } }, { children: "Redo" }), void 0));
    }
    function renderHelpButton() {
        if (isUploadingPhoto || isPhotoTaken)
            return null;
        return (_jsx(Fab, __assign({ size: "medium", className: "workflow-step-view__help-button", onClick: function () { return setIsHelpDialogOpen(true); } }, { children: _jsx(HelpOutlineOutlinedIcon, {}, void 0) }), void 0));
    }
    function renderHelpDialog() {
        return (_jsx(WorkflowStepHelp, { step: props.step, isOpen: isHelpDialogOpen, onClose: function () { return setIsHelpDialogOpen(false); } }, void 0));
    }
    function renderStepsIndicator() {
        if (isPhotoMode)
            return null;
        return (_jsx("div", __assign({ className: "workflow-step-view__steps-indicator" }, { children: _jsxs("span", { children: [props.index + 1, " / ", props.totalSteps] }, void 0) }), void 0));
    }
    function renderProgress() {
        if (!isUploadingPhoto)
            return null;
        return (_jsx("div", __assign({ className: "workflow-step-view__progress" }, { children: _jsx(CircularProgress, {}, void 0) }), void 0));
    }
    function renderOverlay() {
        var _a;
        return null;
        if (!isPhotoMode || isPhotoTaken || !overlayUrl)
            return null;
        var videoCtrl = document.getElementById('idLocalVideoControl');
        var clientHeight = (_a = videoCtrl === null || videoCtrl === void 0 ? void 0 : videoCtrl.clientHeight) !== null && _a !== void 0 ? _a : 0;
        var width = videoCtrl === null || videoCtrl === void 0 ? void 0 : videoCtrl.videoWidth;
        var height = videoCtrl === null || videoCtrl === void 0 ? void 0 : videoCtrl.videoHeight;
        var aspectRatio = width && height ? width / height : 1.77777;
        var img = overlayUrl.toLowerCase().indexOf(".svg?") === -1
            ? (_jsx("img", { src: overlayUrl, alt: "Overlay", style: {
                    height: clientHeight + "px",
                    aspectRatio: aspectRatio.toFixed(5)
                } }, void 0))
            : (_jsx("svg", { children: _jsx("image", { xlinkHref: overlayUrl }, void 0) }, void 0));
        return (_jsx("div", __assign({ className: "workflow-step-view__overlay" }, { children: img }), void 0));
    }
    return (_jsxs("div", __assign({ className: "workflow-step-view" }, { children: [renderOverlay(), renderHeader(), renderLogo(), renderStartButton(), renderCancelButton(), renderFinishButton(), renderTakePhotoButton(), renderAcceptPhotoButton(), renderRedoPhotoButton(), renderHelpButton(), renderHelpDialog(), renderStepsIndicator(), renderProgress(), renderFooter()] }), void 0));
}
